'use client'

import React, { useState } from 'react'
import Image from 'next/image'
import styles from './styles.module.scss'
import CommsCard from '../CommsCard'
import ComplaintSection from '../ComplaintSection'
import CommsModal from '../CommsModal'

const ContactChannelBase = ({ isMobile, isModalOpen, handleModalOpen, ...props }) => {
  const [modalContent, setModalContent] = useState(null)
  const handleCtaClick = modalData => {
    setModalContent(modalData)
    handleModalOpen(true)
  }
  const {
    heading,
    comms_cards: cards,
    complaint_section: complaintData,
    support_Image: supportImg,
  } = props?.contact_channel?.data?.attributes

  return (
    <div className={styles.contactWrapper}>
      <div className={styles.mainContent}>
        <h2 className={styles.heading}>{heading}</h2>
        <div className={styles.cardGroup}>
          {cards.data.map((card, idx) => (
            <CommsCard key={idx} data={card} onCtaClick={handleCtaClick} />
          ))}
        </div>

        <div className={styles.divider} />

        <ComplaintSection data={complaintData} />
      </div>

      {supportImg?.data.attributes.url && (
        <div className={styles.supportImage}>
          <Image
            src={supportImg?.data.attributes.url}
            alt="Support Staff"
            width={800}
            height={1000}
            objectFit="contain"
          />
        </div>
      )}

      <CommsModal
        isModalOpen={isModalOpen}
        handleModalOpen={handleModalOpen}
        content={modalContent}
        isMobile={isMobile}
      />
    </div>
  )
}

export default ContactChannelBase
